import React, { useEffect, useState } from "react";
import { Close } from "@material-ui/icons";
import { FORM_TYPES } from "common/utils/formUtility";
import { useSelector } from "react-redux";
import * as R from "ramda";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Divider,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { getSchoolsList } from "components/master/utils";
import { getDetailsById, onAddValue } from "components/listOfValues/utils";
import { PAGES } from "state/slices/pageSlice";
import ManageSchoolForm from "./ManageSchoolForm";

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  annualPlanCard: {
    marginBottom: "30px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "end",
  },
  heading: {
    fontWeight: 800,
    fontSize: "18px",
    color: "#263657",
  },
  divider: {
    margin: "0 24px 24px 24px",
  },
}));

function ManageSchoolModal(props) {
  const { userRoles, setModalState, modalState } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const [state, setState] = useState({
    name: "",
    gradeName: "",
    subject: {},
    start: "",
    end: "",
  });
  const isEditForm = modalState.isEdit || false;

  useEffect(() => {
    const { data } = modalState;
    if (isEditForm && data?.id) {
      getPlanDetails(data.id);
    }
  }, [isEditForm]);

  const getPlanDetails = async (id) => {
    const response = await getDetailsById("/schools", id);
    const responseData = {
      ...response,
      gradeName: response?.curriculumContext?.gradeName || "",
      subject: {
        value: response.curriculumContext?.subjectValue || "",
        name: response.curriculumContext?.subjectName || "",
      },
    };
    setState(responseData || null);
  };

  const handleClose = () => {
    setModalState((prev) => ({
      isOpen: false,
      data: null,
      isEdit: false,
    }));
  };

  const handleChange = (check, value) => {
    setState((prev) => ({
      ...prev,
      [check]: value,
    }));
  };

  const manageSchoolFormData = useSelector(
    (state) => state.globalForm[FORM_TYPES.MANAGE_SCHOOL]
  );

  const AllowedRoles = ["System Administrator", "Administrator"];

  const isEditEnabled = (roles) => {
    let editEnabled = false;
    if (roles && roles.length > 0) {
      roles.forEach((role) => {
        if (R.includes(role, AllowedRoles)) {
          editEnabled = true;
        }
      });
    }
    return editEnabled;
  };

  const isReadOnly = isEditEnabled(userRoles)
    ? false
    : R.propOr("", "status", manageSchoolFormData) === "COMPLETED";

  const handleSubmit = async (e, schoolStatus = "ACTIVE") => {
    const payload = getSchoolsList(state, schoolStatus); // not sure about utils name here
    const response = await onAddValue(payload, PAGES.schools);
    // getAnnualPlanList?.();
    setModalState({
      isOpen: false,
      isEdit: false,
      data: null,
    });
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={true}
      fullScreen={isSmallDevice}
      onClose={() => setModalState((prev) => ({ ...prev, isOpen: false }))}
      ariaLabeledBy="form-dialog-title"
    >
      <Grid container>
        <Grid item xs={11}>
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6" className={classes.heading}>{`${
              isEditForm ? "Edit" : "Add"
            } School`}</Typography>
          </DialogTitle>
        </Grid>
        <Grid item xs={1} className={classes.modalCloseBtn}>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <DialogContent style={{ padding: "8px 25px" }}>
        <Box>
          <ManageSchoolForm
            formType={FORM_TYPES.MANAGE_SCHOOL}
            isEditForm={isEditForm}
            isReadOnly={isReadOnly}
            state={state}
            handleChange={handleChange}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              pt: 2,
            }}
          >
            <Button
              color="primary"
              // disabled={isReadOnly || isNew}
              variant="contained"
              onClick={handleSubmit}
              data-html2canvas-ignore
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ManageSchoolModal;
